import React, { createContext, useContext, useReducer } from "react";
import { initialState, reducer } from "../reducer";
import { fetchBrunch, fetchCocktails, fetchFood } from "../utils/csvUtils";
import { fetchErs } from "../api/ers";

export const EtcContext = createContext();

export const EtcProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, {
    ...initialState
  });

  // ERS data is now fetched dynamically by slug
  React.useEffect(() => {
    const fetchData = async () => {
      try {
        const [foodDataArray, cocktailsDataArray, brunchDataArray] =
          await Promise.all([fetchFood(), fetchCocktails(), fetchBrunch()]);
        dispatch({ type: "SET_FOOD_DATA", payload: foodDataArray });
        dispatch({ type: "SET_COCKTAILS_DATA", payload: cocktailsDataArray });
        dispatch({ type: "SET_BRUNCH_DATA", payload: brunchDataArray });
      } catch (error) {
        console.error("Encountered an error:", error);
      }
    };
    fetchData();
  }, []);

  // Fetch ERS data by slug, cache in state (memoized)
  const fetchErsData = React.useMemo(() => {
    return async (slug) => {
      if (!slug) return;
      if (state.ersData && state.ersData[slug]) {
        // Already cached
        return state.ersData[slug];
      }
      try {
        const data = await fetchErs(slug);
        dispatch({ type: "SET_ERS_DATA", payload: { slug, data } });
        return data;
      } catch (error) {
        dispatch({ type: "SET_ERS_ERROR", payload: error.message });
        throw error;
      }
    };
  }, [state.ersData, dispatch]);

  const value = {
    state,
    dispatch,
    fetchErsData,
  };

  return (
    <EtcContext.Provider value={value}>
      {children}
    </EtcContext.Provider>
  );
};

export const useEtc = () => useContext(EtcContext);
